import { render, staticRenderFns } from "./infoUserType-rejectList.vue?vue&type=template&id=128b13ce&scoped=true&"
import script from "./infoUserType-rejectList.vue?vue&type=script&lang=js&"
export * from "./infoUserType-rejectList.vue?vue&type=script&lang=js&"
import style0 from "./infoUserType-rejectList.vue?vue&type=style&index=0&id=128b13ce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b13ce",
  null
  
)

export default component.exports